import React, { useCallback, useId } from 'react'
import { FloatingLabel, Form, InputGroup } from 'react-bootstrap'

interface NumberInputProps {
    label: React.ReactNode
    prefix: React.ReactNode
    suffix: React.ReactNode
    value: string
    errorMessages: Array<string>
    min?: number
    max?: number
    step?: number
    hint: React.ReactNode
    onChange: (value: string) => Promise<void>
    disabled?: boolean
}

const NumberInput: React.FC<NumberInputProps> = ({
    label,
    prefix = '',
    suffix = '',
    value,
    errorMessages,
    min,
    max,
    step,
    hint,
    onChange,
    disabled = false,
}) => {
    const id = useId()

    const handleChange = useCallback(
        async (event: React.ChangeEvent<HTMLInputElement>) => {
            await onChange(event.target.value)
        },
        [onChange],
    )

    const floatingLabel = (
        <FloatingLabel controlId={id} label={label}>
            <Form.Control
                onChange={handleChange}
                type="number"
                min={min}
                max={max}
                step={step}
                value={value}
                isInvalid={errorMessages.length > 0} // Ensure this is set
                disabled={disabled}
                autoComplete="off"
            />
            <Form.Control.Feedback type="invalid">
                {errorMessages.join(' ')} {/* Display error messages */}
            </Form.Control.Feedback>
        </FloatingLabel>
    )

    return (
        <div className="mb-3">
            {prefix || suffix ? (
                <InputGroup>
                    {prefix && <InputGroup.Text>{prefix}</InputGroup.Text>}
                    {floatingLabel}
                    {suffix && <InputGroup.Text>{suffix}</InputGroup.Text>}
                </InputGroup>
            ) : (
                floatingLabel
            )}
            {hint && <Form.Text>{hint}</Form.Text>}
        </div>
    )
}

export default NumberInput
